export class CookieHelper
{
    static getCookie(name)
    {
        return document.cookie.split(';').find(c => c.trim().startsWith(name + '='))
            ?.trim().substring(name.length + 1) || null;
    }

    static setCookie(name, value, days, options = {})
    {
        const d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));

        const defaultOptions = { path: '/', sameSite: 'Lax', ...options};
        const attributes = Object.entries(defaultOptions)
        .map(([k, v]) => `${k}=${v}`)
        .join('; ');

        // Added Secure outside the options object scope because it does not follow your usual key=value structure.
        document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + '; ' + attributes + (location.protocol === 'https:' ? '; Secure' : '');
    }
}
